module.exports = __webpack_public_path__ + "img/index-ydn.20cd6bab.png";